/**
 * Created by sung on 2017-02-07.
 */
import {NgModule, Component, OnInit} from '@angular/core';
import {PanelModule,InputTextareaModule,ButtonModule,SharedModule} from 'primeng/primeng';
import {MamAdminService} from "../../service/mam_service.component";


import {FormsModule} from "@angular/forms";
import {HttpModule} from "@angular/http";
import {BrowserModule} from "@angular/platform-browser";
import {CommonModule} from "@angular/common";


import {Logger, Options, Level } from "angular2-logger/core";
import {TranslatePipeMoudle} from "../../translate/translate.module.pipe";
import {TranslateServiceForm} from "../../translate/translate.service"; // ADD THIS


@Component({
  selector:'user-agreement-management',
  templateUrl:'user_agreement_management.html'
})
export class UserAgreementManagementComponent implements OnInit {
  content: string;
  translate : TranslateServiceForm;
  constructor(private service : MamAdminService, private logger : Logger, private _translate : TranslateServiceForm){
    //this.content = "<p>본 프로그램을 설치하시면 관리자에 의해 기기의 사용이 제한되거나 제어될 수 있습니다.</p>";
    this.translate = _translate;
  }
  ngOnInit(): void {
    this.userConfirm();
  }

  userConfirm() {
    this.service.userConfirm().subscribe(
        value => {
          this.content = value;

        },
        error => {this.logger.error("-- user_confirm : " + error);},
        () => {

        }
    )

  }

  save() {
    this.service.updateUserConfirm(this.content).subscribe(
        value => {},
        error => {this.logger.error("-- user_confirm : " + error);},
        () => {alert(this.translate.instant('MESSAGE_Save_Complete'));}
    )
  }

}

@NgModule({
  imports:[PanelModule,SharedModule, CommonModule,BrowserModule,HttpModule,FormsModule,InputTextareaModule,ButtonModule,TranslatePipeMoudle],
  declarations:[UserAgreementManagementComponent],
  exports:[UserAgreementManagementComponent],
  providers:[MamAdminService]
})
export class UserAgreementManagementModule{

}



// WEBPACK FOOTER //
// ./src/app/page/system/user_agreement_management.ts